
export const currentSession = (state) => state.currentSession
export const currentShopBox = (state) => state.currentShopBox
export const getBoxes = (state) => state.boxes
export const getShop = (state) =>  (state.currentShopBox ? state.currentShopBox.shop : {})
export const getSellerName = function (state) {
    return state.sellerName
}
export const getSellerId = function (state) {
    return state.sellerId
}
export const getCompany = (state) => {
    return state.company
}
export const getCurrency = (state) => {
    return state.currency
}
